export default "https://assets.pclncdn.com/web/next-landing/49d3d019e1/_next/static/images/miami-6ea7a135a72b075e2fd3d7544b4279e8.jpg";